import React from "react";
import hearderbg from "../Assest/new_logo_withshreebalaji.png"

export default function Disclaimer() {
  return (
    <div className="text-gray-800 overflow-hidden">

      {/* HERO */}

         <section
        className="relative py-28 bg-cover bg-center"
        style={{
          backgroundImage: `url(${hearderbg})`,
        }}
      >
        {/* Dark overlay for readability */}
        {/* <div className="absolute inset-0 bg-black/60"></div> */}

        {/* Optional gradient overlay for premium feel */}
        <div className="absolute inset-0 bg-gradient-to-br from-[#2C3E5C]/70 via-[#1F2A44]/60 to-[#000]/50"></div>

        <div className="relative z-10 max-w-7xl mx-auto px-6 text-center text-white animate-fadeUp">
          <h1 className="text-4xl md:text-5xl font-bold mb-4">
           Disclaimer
          </h1>
          <p className="text-lg md:text-xl max-w-3xl mx-auto text-white/90">
             Important information about fraud prevention and data safety.
          </p>
        </div>
      </section>
      {/* <section className="relative py-28 bg-gradient-to-br from-indigo-600 via-purple-600 to-cyan-500">
        <div className="absolute inset-0 bg-black/30"></div>

        <div className="relative z-10 max-w-7xl mx-auto px-6 text-center text-white">
          <h1 className="text-4xl md:text-5xl font-bold mb-4">
            Disclaimer
          </h1>
          <p className="text-lg md:text-xl max-w-3xl mx-auto text-white/90">
            Important information about fraud prevention and data safety.
          </p>
        </div>
      </section> */}

      {/* DISCLAIMER CONTENT */}
      <section className="relative py-24 bg-gradient-to-b from-slate-50 to-white">
        <div className="max-w-7xl mx-auto px-6 space-y-10">

          {/* Fraud Warning */}
          <div className="glass rounded-2xl p-10 shadow-xl animate-fadeUp">
            <h2 className="text-2xl font-bold text-indigo-600 mb-4">
              Beware of Fraudulent Activities
            </h2>
            <p className="text-gray-700 leading-relaxed">
              BingoPays never requests advance payments such as fees, charges,
              fixed deposits, demand drafts, or similar for any purpose. We also
              do not offer gifts or vouchers tied to financial deals. If you
              receive such requests supposedly from BingoPays, they are
              fraudulent — do not respond to them.
            </p>
          </div>

          {/* Protect Your Data */}
          <div className="glass rounded-2xl p-10 shadow-xl animate-fadeUp">
            <h2 className="text-2xl font-bold text-indigo-600 mb-4">
              Protect Your Sensitive Information
            </h2>
            <p className="text-gray-700 leading-relaxed">
              BingoPays will never ask for your login credentials, OTPs, bank
              account or card details, CVV, grid values, or personal identity
              details like income proof, via email, SMS, or phone. Any such
              request is unauthorized and should be reported immediately.
            </p>
          </div>

          {/* Stay Vigilant */}
          <div className="glass rounded-2xl p-10 shadow-xl animate-fadeUp">
            <h2 className="text-2xl font-bold text-indigo-600 mb-4">
              Stay Vigilant Against Fraud
            </h2>
            <p className="text-gray-700 leading-relaxed">
              If you receive communication via email, SMS, or phone asking for
              advance payments or sensitive information, do not engage with it.
              Fraudulent attempts can lead to financial loss or misuse of your
              personal information. Always verify the authenticity before
              responding.
            </p>
            <p className="text-gray-700 leading-relaxed mt-3">
              BingoPays is not responsible for losses caused by unauthorized
              dealings. Please report suspicious activity promptly to the
              appropriate authorities and remain vigilant to protect your
              financial and personal information.
            </p>
          </div>

        </div>
      </section>

    </div>
  );
}
